import { render, staticRenderFns } from "./CardPaymentInQuotas.vue?vue&type=template&id=1b67aa62&scoped=true&"
import script from "./CardPaymentInQuotas.vue?vue&type=script&lang=js&"
export * from "./CardPaymentInQuotas.vue?vue&type=script&lang=js&"
import style0 from "./CardPaymentInQuotas.vue?vue&type=style&index=0&id=1b67aa62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67aa62",
  null
  
)

export default component.exports